import React, { useEffect, useState, useRef } from "react";
import styles from "../../../assets/stylesheets/sass/CustomerFiles.module.scss";
import style from "../../../assets/stylesheets/sass/UserManagement.module.scss";

import check_white from "../../../assets/icons/check_white.svg";

import bin_icon_white from "../../../assets/icons/bin_icon_white.svg";
import bin_icon_black from "../../../assets/icons/bin_icon_black.svg";

import {getFitDocToken} from "../../../functions/token.js";
import Dropdownlist from "../../customComponents/Dropdownlist";

import settings_icon_white from "../../../assets/icons/settings_icon_white.svg";
import refresh_icon_white from "../../../assets/icons/refresh_icon_white.svg";


import backarrow_icon_white from "../../../assets/icons/backarrow_icon_white.svg";
import warning_icon_white from "../../../assets/icons/warning_icon_white.svg";

import localForage from "localforage";

import DatepickerRange from "../../customComponents/DatepickerRange";
import LoadingStatus from "../../customComponents/LoadingStatus";
import LoadingContainer from "../../customComponents/LoadingContainer";

import arrow_down_black from "../../../assets/icons/arrow_down_black.svg";
import sort_icon_black from "../../../assets/icons/sort_icon_black.svg";

import visibilityON_icon_black from "../../../assets/icons/visibilityON_icon_black.svg";
import visibilityOFF_icon_black from "../../../assets/icons/visibilityOFF_icon_black.svg";
import { useDetectClickOutside } from 'react-detect-click-outside';
import { Document, Page, pdfjs   } from "react-pdf";
import calendar_white from "../../../assets/icons/calendar_white.svg";

// import Qastan from "@qastanfit/logger"
import { ReactSession }  from 'react-client-session';
import { useDispatch, useSelector } from "react-redux"
import GroupsPopup from "./Management/GroupsPopup";
import { convertRelationRelnrToName } from "../../../functions/conversions";
import { handleCreateGroup, handleUpdateGroup } from "../../../functions/updates";
import { handleGetAllGroups } from "../../../functions/fetch";
import { setAllGroups } from "../../../redux/actions/index";

import CompleteTable from "./Management/CompleteTable";
import UserGroups from "./Management/UserGroups/UserGroup";
import Tablist from "../../ui/Tablist";
import UserRights from "./Management/UserRights";
import { Toaster, toast } from "react-hot-toast";
import lodash from 'lodash'

import { Input } from "../../ui/input";
import { Edit2Icon, FilterIcon, MailIcon, TrashIcon, XIcon } from "lucide-react";
import { TooltipContent, Tooltip, TooltipProvider, TooltipTrigger } from "../../ui/tooltip";

import AddUser from "./Management/AddUser/AddUser"
import EditUser from "./Management/AddUser/EditUser";

export function Checkbox({label, onChange, color, checked}){
    const [check, setcheck] = useState(checked);
    return (
        <label className={style.checkbox_container}>{label}
            <input type="checkbox" defaultChecked={checked} onChange={(e)=>{onChange(e); setcheck(e.currentTarget.checked)}}/>
            <span style={check ? {backgroundColor:color} : {}} className={style.checkbox_checkmark}></span>
        </label>
    )
}

export function BdocCard({name, onChange, checked, id, viewDocument}){

    const button = useRef(null);

    const selectBdoc = (e) => {
        if(e.target !== button.current){
            onChange(id); 
        }
    }

    return (
        <div className={checked ? style.bdoc_card_active : style.bdoc_card} onClick={(e)=>{selectBdoc(e)}}>
            <div className={style.bdoc_card_content}>
                <p className={style.bdoc_card_name}>{name}</p>
                <div className={style.bdoc_view_status}><img src={checked ? visibilityON_icon_black : visibilityOFF_icon_black} alt="eye"/></div>
                {/* <div style={{display:"flex"}}>
                    <label className={style.switch}>
                        <input type="checkbox" checked={checked} onChange={(e)=>{onChange(id); setcheck(e.currentTarget.checked)}}/>
                        <span className={style.slider_round}></span>
                    </label>
                </div>  */}
                <button onClick={()=>{viewDocument(true)}} ref={button} className={style.bdoc_card_openbutton}>Bekijk document</button>      
            </div>                      
        </div> 
    )
}

export function Filter({onOutsideClick, content_state, filter_verified, onChangeFilterVerified, onChangeFilterLanguage, filter_language, onChangeSorting, sorting_option, onChangeName, name_search, roles, filter_role, onChangeFilterRole}){
    function ProducttypeOption({ind, value, filter_role, onChangeFilterRole}){        
        const handleToggleRole = () =>{
            let tmp_filter_role = filter_role;
            if(tmp_filter_role.role[value] === undefined){
                tmp_filter_role.role[value] = false;
            }
            else{
                if(!tmp_filter_role.role[value]){
                    delete tmp_filter_role.role[value]
                }
                else{
                    tmp_filter_role.role[value] = !tmp_filter_role.role[value]
                }
            }
            onChangeFilterRole(filter_role)
        }

        function capitalizeFirstLetter(string) {
            return string.charAt(0).toUpperCase() + string.slice(1);
        }

        return (
            <button className={styles.dropdown_option} key={ind} onClick={()=>handleToggleRole()}>
                <div style={{display:"flex", alignItems:"center"}}><img src={filter_role ? ((filter_role.role[value] || filter_role.role[value] === undefined) ? visibilityON_icon_black : visibilityOFF_icon_black) : visibilityOFF_icon_black} alt="icon"/><p>{capitalizeFirstLetter(value)}</p></div>                        
            </button>
        )
    }

    function LanguageOption({value, filter_language, onChangeFilterLanguage}){

        const handleToggleLanguage = () =>{
            let tmp_filter_language = filter_language;
            if(tmp_filter_language === undefined){
                tmp_filter_language = {"language":{}};
            }

            if(tmp_filter_language.language[value] === undefined){
                tmp_filter_language.language[value] = false;
            }
            else{
                if(!tmp_filter_language.language[value]){
                    delete tmp_filter_language.language[value]
                }
                else{
                    tmp_filter_language.language[value] = !tmp_filter_language.language[value]
                }
            }
            onChangeFilterLanguage(filter_language)
        }

        function capitalizeFirstLetter(string) {
            return string.charAt(0).toUpperCase() + string.slice(1);
        }

        return (
            <button className={styles.dropdown_option} onClick={()=>handleToggleLanguage()}>
                <div style={{display:"flex", alignItems:"center"}}><img src={filter_language ? ((filter_language.language[value] || filter_language.language[value] === undefined) ? visibilityON_icon_black : visibilityOFF_icon_black) : visibilityOFF_icon_black} alt="icon"/>
                <p>{capitalizeFirstLetter(value) === "Nederlands" ?
                (content_state[ReactSession.get("language")].General && content_state[ReactSession.get("language")].General.language_dutch ? content_state[ReactSession.get("language")].General.language_dutch : "Dutch")
                : 
                capitalizeFirstLetter(value) === "Frans" ?
                (content_state[ReactSession.get("language")].General && content_state[ReactSession.get("language")].General.language_french ? content_state[ReactSession.get("language")].General.language_french : "French")
                :
                (content_state[ReactSession.get("language")].General && content_state[ReactSession.get("language")].General.language_english ? content_state[ReactSession.get("language")].General.language_english : "English")}</p>
                </div>                        
            </button>
        )
    }

    function VerifiedOption({filter_verified, value, onChangeFilterVerified}){
        const handleToggleVerified = () =>{
            filter_verified = value.toString().toLowerCase();
            onChangeFilterVerified(filter_verified);
        }

        function capitalizeFirstLetter(string) {
            return string.charAt(0).toUpperCase() + string.slice(1);
        }

        return (
            <button className={styles.dropdown_option} onClick={()=>handleToggleVerified()}>
                <div style={{display:"flex", alignItems:"center"}}><img src={(filter_verified === value.toString().toLowerCase() || filter_verified === "all") ? visibilityON_icon_black : visibilityOFF_icon_black} alt="icon"/>
                <p>
                    {capitalizeFirstLetter(value) === "Geverifieerd" ? 
                    (content_state[ReactSession.get("language")] ? (content_state[ReactSession.get("language")].UserManagement && content_state[ReactSession.get("language")].UserManagement.filter_state_verified && content_state[ReactSession.get("language")].UserManagement.filter_state_verified) : "Verified")
                    :
                    (content_state[ReactSession.get("language")] ? (content_state[ReactSession.get("language")].UserManagement && content_state[ReactSession.get("language")].UserManagement.filter_state_unverified && content_state[ReactSession.get("language")].UserManagement.filter_state_unverified) : "Unverified")
                    }</p>
                </div>                        
            </button>
        )
    }


    const [viewDdl, setviewDdl] = useState(null);

    const showAllRoles = () =>{
        onChangeFilterRole({"role": {}})
    }

    const showAllLanguages = () =>{
        onChangeFilterLanguage({"language": {}})
    }

    const handleClickOutside = (e) =>{
        let classNames = []

        if(e.target.name === "filter_button"){return;}

        e.path.forEach(item => { classNames = classNames.concat(item.className)})

        if(!classNames.includes(refFilter.current.className)){
            onOutsideClick(false);
        } 
    }

    const refFilter = useDetectClickOutside({ onTriggered: handleClickOutside });

    return (
        <div className={styles.dropdown_container} ref={refFilter}>  

            {!viewDdl ?
            <> 
            <p className={styles.dropdown_title}>{content_state[ReactSession.get("language")] ? (content_state[ReactSession.get("language")].UserManagement && content_state[ReactSession.get("language")].UserManagement.filter_title && content_state[ReactSession.get("language")].UserManagement.filter_title) : "Filter options"}</p>     
            
            {/* Sorteren knop */ }
            <button className={styles.dropdown_option} onClick={()=>setviewDdl("sorting")}>
                <div style={{display:"flex", alignItems:"center"}}><img className={styles.dropdown_option_image} src={sort_icon_black} alt="sort icon"/><p>{content_state[ReactSession.get("language")] ? (content_state[ReactSession.get("language")].UserManagement && content_state[ReactSession.get("language")].UserManagement.filter_sort_subtitle && content_state[ReactSession.get("language")].UserManagement.filter_sort_subtitle) : "Sort by"}</p></div>
                <div className={styles.dropdown_second_option}>
                    <p>{sorting_option === "E-mailadres" ?
                        (content_state[ReactSession.get("language")] ? (content_state[ReactSession.get("language")].UserManagement && content_state[ReactSession.get("language")].UserManagement.filter_sort_email && content_state[ReactSession.get("language")].UserManagement.filter_sort_email) : "E-mail address")
                        :
                        (sorting_option === "Rol" ? 
                        (content_state[ReactSession.get("language")] ? (content_state[ReactSession.get("language")].UserManagement && content_state[ReactSession.get("language")].UserManagement.filter_role_subtitle && content_state[ReactSession.get("language")].UserManagement.filter_role_subtitle) : "Role")
                        :
                        (sorting_option === "Voornaam" ?
                        (content_state[ReactSession.get("language")] ? (content_state[ReactSession.get("language")].UserManagement && content_state[ReactSession.get("language")].UserManagement.overview_th_firstname && content_state[ReactSession.get("language")].UserManagement.overview_th_firstname) : "First name")
                        :
                        (sorting_option === "Familienaam" ?
                        (content_state[ReactSession.get("language")] ? (content_state[ReactSession.get("language")].UserManagement && content_state[ReactSession.get("language")].UserManagement.overview_th_lastname && content_state[ReactSession.get("language")].UserManagement.overview_th_lastname) : "Last name")
                        :
                        (sorting_option === "Taal" ?
                        (content_state[ReactSession.get("language")] ? (content_state[ReactSession.get("language")].UserManagement && content_state[ReactSession.get("language")].UserManagement.overview_th_language && content_state[ReactSession.get("language")].UserManagement.overview_th_language) : "Language")
                        :
                        (sorting_option === "Nieuwste eerst" ?
                        (content_state[ReactSession.get("language")] ? (content_state[ReactSession.get("language")].UserManagement && content_state[ReactSession.get("language")].UserManagement.filter_sort_newest && content_state[ReactSession.get("language")].UserManagement.filter_sort_newest) : "Newest first")
                        :
                        (content_state[ReactSession.get("language")] ? (content_state[ReactSession.get("language")].UserManagement && content_state[ReactSession.get("language")].UserManagement.filter_sort_oldest && content_state[ReactSession.get("language")].UserManagement.filter_sort_oldest) : "Oldest first")
                        )))))
                    }</p>
                <img src={arrow_down_black} alt="icon"/></div>                            
            </button>

            {/* Rol checkbox */ }
            <div className={styles.dropdown_subtitle_header}>
                <p className={styles.dropdown_subtitle}>{content_state[ReactSession.get("language")] ? (content_state[ReactSession.get("language")].UserManagement && content_state[ReactSession.get("language")].UserManagement.filter_role_subtitle && content_state[ReactSession.get("language")].UserManagement.filter_role_subtitle) : "Role"}</p>
                <button onClick={()=>{showAllRoles()}}>{content_state[ReactSession.get("language")] ? (content_state[ReactSession.get("language")].UserManagement && content_state[ReactSession.get("language")].UserManagement.filter_role_show && content_state[ReactSession.get("language")].UserManagement.filter_role_show) : "Show all"}</button>
            </div>
            <div>
                
                    {roles.map((v, i)=>{
                        return <React.Fragment key={i}>
                            <ProducttypeOption value={v} filter_role={filter_role} onChangeFilterRole={(value)=>{onChangeFilterRole(value)}}/>
                        </React.Fragment>
                    })}
                
            </div>

            {/* Naam inputvelden */ }
            <div className={styles.dropdown_subtitle_header}>
                <div className={styles.dropdown_inputfield_container}>
                    <p className={styles.dropdown_subtitle}>{content_state[ReactSession.get("language")] ? (content_state[ReactSession.get("language")].UserManagement && content_state[ReactSession.get("language")].UserManagement.filter_name_subtitle && content_state[ReactSession.get("language")].UserManagement.filter_name_subtitle) : "Name"}</p>
                    <input type="text" className={styles.dropdown_option_inputfield} placeholder={content_state[ReactSession.get("language")] ? (content_state[ReactSession.get("language")].UserManagement && content_state[ReactSession.get("language")].UserManagement.filter_name_placeholder && content_state[ReactSession.get("language")].UserManagement.filter_name_placeholder) : "Search..."} value={name_search} onChange={(e)=>{onChangeName(e.currentTarget.value)}}/>
                </div>     
            </div>

            {/* Taal checkbox */ }
            <div className={styles.dropdown_subtitle_header}>
                <p className={styles.dropdown_subtitle}>{content_state[ReactSession.get("language")] ? (content_state[ReactSession.get("language")].UserManagement && content_state[ReactSession.get("language")].UserManagement.filter_language_subtitle && content_state[ReactSession.get("language")].UserManagement.filter_language_subtitle) : "Language"}</p>
                <button onClick={()=>{showAllLanguages()}}>{content_state[ReactSession.get("language")] ? (content_state[ReactSession.get("language")].UserManagement && content_state[ReactSession.get("language")].UserManagement.filter_role_show && content_state[ReactSession.get("language")].UserManagement.filter_role_show) : "Show all"}</button></div>
            <div>
        
                {["Nederlands", "Frans", "Engels"].map((v, i)=>{
                    return <React.Fragment key={i}>
                        <LanguageOption value={v} filter_language={filter_language} onChangeFilterLanguage={(value)=>{onChangeFilterLanguage(value)}}/>
                    </React.Fragment>
                })}
                
            </div>

            {/* Status radiobutton */ }
            <div className={styles.dropdown_subtitle_header}>
                <p className={styles.dropdown_subtitle}>{content_state[ReactSession.get("language")] ? (content_state[ReactSession.get("language")].UserManagement && content_state[ReactSession.get("language")].UserManagement.filter_state_subtitle && content_state[ReactSession.get("language")].UserManagement.filter_state_subtitle) : "Status"}</p>
                <button onClick={()=>{onChangeFilterVerified("all")}}>{content_state[ReactSession.get("language")] ? (content_state[ReactSession.get("language")].UserManagement && content_state[ReactSession.get("language")].UserManagement.filter_role_show && content_state[ReactSession.get("language")].UserManagement.filter_role_show) : "Show all"}</button>
            </div>
            <div>
                <React.Fragment>
                    <VerifiedOption filter_verified={filter_verified} onChangeFilterVerified={(value)=>{onChangeFilterVerified(value)}} value={"Geverifieerd"}/>
                    <VerifiedOption filter_verified={filter_verified} onChangeFilterVerified={(value)=>{onChangeFilterVerified(value)}} value={"Niet geverifieerd"}/>
                </React.Fragment>
            </div>
            </>  

            :
            viewDdl === "sorting" &&
            <>
            <div onClick={()=>{setviewDdl(null)}} className={styles.dropdown_title_sorting_header}><img src={arrow_down_black} alt="icon"/><p className={styles.dropdown_title}>{content_state[ReactSession.get("language")] ? (content_state[ReactSession.get("language")].UserManagement && content_state[ReactSession.get("language")].UserManagement.filter_sort_subtitle && content_state[ReactSession.get("language")].UserManagement.filter_sort_subtitle) : "Sort by"}</p></div>

            <button className={sorting_option === "E-mailadres" ? styles.dropdown_option_sortingACTIVE : styles.dropdown_option_sorting} name="E-mailadres" onClick={()=>{onChangeSorting("E-mailadres"); setviewDdl(null)}}>
                <div style={{display:"flex", alignItems:"center", justifyContent:"space-between", width:"100%", paddingLeft:".3rem"}}>
                    <p>{content_state[ReactSession.get("language")] ? (content_state[ReactSession.get("language")].UserManagement && content_state[ReactSession.get("language")].UserManagement.filter_sort_email && content_state[ReactSession.get("language")].UserManagement.filter_sort_email) : "E-mail address"}</p>
                <img className={styles.dropdown_option_image} src={sort_icon_black} alt="sort icon"/></div>
            </button>
            <button className={sorting_option === "Rol" ? styles.dropdown_option_sortingACTIVE : styles.dropdown_option_sorting} name="Rol" onClick={()=>{onChangeSorting("Rol"); setviewDdl(null)}}>
                <div style={{display:"flex", alignItems:"center", justifyContent:"space-between", width:"100%", paddingLeft:".3rem"}}>
                    <p>{content_state[ReactSession.get("language")] ? (content_state[ReactSession.get("language")].UserManagement && content_state[ReactSession.get("language")].UserManagement.filter_role_subtitle && content_state[ReactSession.get("language")].UserManagement.filter_role_subtitle) : "Role"}</p>
                <img className={styles.dropdown_option_image} src={sort_icon_black} alt="sort icon"/></div>
            </button>
            <button className={sorting_option === "Voornaam" ? styles.dropdown_option_sortingACTIVE : styles.dropdown_option_sorting} name="Voornaam" onClick={()=>{onChangeSorting("Voornaam"); setviewDdl(null)}}>
                <div style={{display:"flex", alignItems:"center", justifyContent:"space-between", width:"100%", paddingLeft:".3rem"}}>
                    <p>{content_state[ReactSession.get("language")] ? (content_state[ReactSession.get("language")].UserManagement && content_state[ReactSession.get("language")].UserManagement.overview_th_firstname && content_state[ReactSession.get("language")].UserManagement.overview_th_firstname) : "First name"}</p>
                <img className={styles.dropdown_option_image} src={sort_icon_black} alt="sort icon"/></div>
            </button>
            <button className={sorting_option === "Familienaam" ? styles.dropdown_option_sortingACTIVE : styles.dropdown_option_sorting} name="Familienaam"onClick={()=>{onChangeSorting("Familienaam"); setviewDdl(null)}} >
                <div style={{display:"flex", alignItems:"center", justifyContent:"space-between", width:"100%", paddingLeft:".3rem"}}>
                    <p>{content_state[ReactSession.get("language")] ? (content_state[ReactSession.get("language")].UserManagement && content_state[ReactSession.get("language")].UserManagement.overview_th_lastname && content_state[ReactSession.get("language")].UserManagement.overview_th_lastname) : "Last name"}</p>
                <img className={styles.dropdown_option_image} src={sort_icon_black} alt="sort icon"/></div>
            </button>
            <button className={sorting_option === "Taal" ? styles.dropdown_option_sortingACTIVE : styles.dropdown_option_sorting} name="Taal" onClick={()=>{onChangeSorting("Taal"); setviewDdl(null)}}>
                <div style={{display:"flex", alignItems:"center", justifyContent:"space-between", width:"100%", paddingLeft:".3rem"}}>
                    <p>{content_state[ReactSession.get("language")] ? (content_state[ReactSession.get("language")].UserManagement && content_state[ReactSession.get("language")].UserManagement.overview_th_language && content_state[ReactSession.get("language")].UserManagement.overview_th_language) : "Language"}</p>
                <img className={styles.dropdown_option_image} src={sort_icon_black} alt="sort icon"/></div>
            </button>
            <button className={sorting_option === "Nieuwste eerst" ? styles.dropdown_option_sortingACTIVE : styles.dropdown_option_sorting} name="Nieuwste eerst" onClick={()=>{onChangeSorting("Nieuwste eerst"); setviewDdl(null)}}>
                <div style={{display:"flex", alignItems:"center", justifyContent:"space-between", width:"100%", paddingLeft:".3rem"}}>
                    <p>{content_state[ReactSession.get("language")] ? (content_state[ReactSession.get("language")].UserManagement && content_state[ReactSession.get("language")].UserManagement.filter_sort_newest && content_state[ReactSession.get("language")].UserManagement.filter_sort_newest) : "Newest first"}</p>
                <img className={styles.dropdown_option_image} src={sort_icon_black} alt="sort icon"/></div>
            </button>
            <button className={sorting_option === "Oudste eerst" ? styles.dropdown_option_sortingACTIVE : styles.dropdown_option_sorting} name="Oudste eerst" onClick={()=>{onChangeSorting("Oudste eerst"); setviewDdl(null)}}>
                <div style={{display:"flex", alignItems:"center", justifyContent:"space-between", width:"100%", paddingLeft:".3rem"}}>
                    <p>{content_state[ReactSession.get("language")] ? (content_state[ReactSession.get("language")].UserManagement && content_state[ReactSession.get("language")].UserManagement.filter_sort_oldest && content_state[ReactSession.get("language")].UserManagement.filter_sort_oldest) : "Oldest first"}</p>
                <img className={styles.dropdown_option_image} src={sort_icon_black} alt="sort icon"/></div>
            </button>
            </>
            }

        </div>
    )
}

let dataFetchRights = []
export default function UserManagement(){
    const alldoctypes = useSelector(state => state.doctypes);
    const doctypesTranslations = useSelector(state => state.doctypesTranslations);
    const filetypesTranslations = useSelector(state => state.filetypesTranslations)

    const [content_state, setcontent_state] = useState({});


    const [clearDoctypesDdl, setclearDoctypesDdl] = useState(false);

    const [users, setusers] = useState([]);
    const [users_main, setusers_main] = useState([]);    

    const [selectedSubpage, setselectedSubpage] = useState("Overzicht");

    const [roles, setroles] = useState([]);
    const [roles_labels, setroles_labels] = useState([]);

    const [showWarningDeleteUser, setshowWarningDeleteUser] = useState(false);
    const [name_todelete, setname_todelete] = useState("");
    const [id_todelete, setid_todelete] = useState();

    const [sendMailStatus, setsendMailStatus] = useState(0);

    const [dostypes, setdostypes] = useState([]);
    const [doctypes, setdoctypes] = useState([]);

    const [selectedDoctypes, setselectedDoctypes] = useState([]);

    const [updateStatus, setupdateStatus] = useState("standard");

    const [dosrights, setdosrights] = useState([]);
    const [dosright, setdosright] = useState([]);
    const [view_portalsettings, setview_portalsettings] = useState(false);

    const [showMenu, setshowMenu] = useState(false);
    const [redirectRights, setredirectRights] = useState(false);
    
    const [listitems, setlistitems] = useState([]);
    const [tableitems, settableitems] = useState([]);

    const [adminSettings, setadminSettings] = useState({});

    const [load_users, setload_users] = useState("loading");
    const [load_rights, setload_rights] = useState("loading");

    const [rights_subpage, setrights_subpage] = useState('1')


    const checkDosRight = () =>{
        let tmp_dosright = [...dosright];
        let tmp_tableitems = [...tableitems];

        if(tmp_dosright){
            for (let i = 0; i < tmp_dosright.length; i++) {   
                if(tmp_dosright[i].doctypes){
                    for (let j = 0; j < tmp_dosright[i].doctypes.length; j++) {
                        if(!tmp_tableitems.includes(tmp_dosright[i].doctypes[j].doctype)){
                            tmp_dosright[i].doctypes.splice(j, 1);
                        }
                    }
                }
            }

            if(Array.isArray(dostypes)){
                for (let i = 0; i < dostypes.length; i++) {
                    const dostype = dostypes[i]
                    const existingItem = tmp_dosright.find(i=>i.filetype===dostype.dossiertypeid)
                    
                    if(!existingItem){
                        const doctypesArray = tableitems.map((doctype)=>{return({doctype:doctype, users:[]})})

                        tmp_dosright.push({filetype:dostype.dossiertypeid, doctypes:doctypesArray}) 
                    }
                }
            }

            setdosrights(tmp_dosright)

            let finalObject = {}
            finalObject.filetypes = tmp_dosright;
            let dataRightsObject = {          
                "token": window.localStorage.getItem("token"),
                "data": finalObject
            }


            handleFiletypeAddSettings(dataRightsObject);
        }
        
    }

    useEffect(()=>{        
        if(dostypes && tableitems && roles){
            if(dostypes.length > 0 && tableitems.length > 0 && roles.length > 0){
                //console.log(dosright, tableitems)
                if(dosright.length > 0 && tableitems[0] !== null){
                    //set previous rights
                    checkDosRight()
                    //setshowMenu(true);
                    setredirectRights(false);
                    
                }

                else {
                    //create new rights
                    //setshowMenu(true);
                    if(tableitems[0] === null){
                        setredirectRights(true);
                    }
                    else{
                        //createRights();
                    }
                }         
            }
        }
        
    }, [dostypes, tableitems, dosright, roles])

    const allroles = useSelector(state => state.roles)
    const allroleslabels = useSelector(state => state.roleslabels)

    const [groupDropdownData, setgroupDropdownData] = useState([]);
    
    useEffect(()=>{
        let cancel = false;

        fetch(process.env.REACT_APP_SERVER_LINK+"content").then(
            res => res.json()
        ).then(
            json => {
                if (cancel) return;
                setcontent_state(json)
            }
        )

        const fetching = async () =>{
            let lfAdminSettings = await localForage.getItem("adminSettings");
            let lfTableItems = await localForage.getItem("tableItems");
            let lfListItems = await localForage.getItem("listItems");
            let lfDosRight = await localForage.getItem("dosRight");
            let lfUsers = await localForage.getItem("users");
            let lfRoles = allroles;
            let lfRolesLabels = allroleslabels;
            
            if(lfAdminSettings){ setadminSettings(lfAdminSettings); setfixedDocSettings(lfAdminSettings.json.fixed_docs)}
            if(lfTableItems) settableitems(lfTableItems)
            if(lfListItems) setlistitems(lfListItems)
            if(lfDosRight) setdosright(lfDosRight)
            if(lfUsers) {setusers(lfUsers); setusers_main(lfUsers); setload_users("success");} 
            if(lfRoles) setroles(lfRoles)
            if(lfRolesLabels) setroles_labels(lfRolesLabels)

            const resAdminSettings = await fetch(process.env.REACT_APP_SERVER_LINK+"adminSettingsGet?token="+window.localStorage.getItem("token"), {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                },
            });

            let resultAdminSettings = await resAdminSettings.json();
            //console.log(resultAdminSettings)
            if(resultAdminSettings.object){
                if(resultAdminSettings.object.json){
                    //console.log(resultAdminSettings.object.json)
                    if (cancel) return; 
                    setadminSettings(resultAdminSettings.object);
                    if(resultAdminSettings.object.json.table_items){
                        if (cancel) return;
                        //setshowMenu(true);
                        setredirectRights(false);
                        setNewListItems(alldoctypes, resultAdminSettings.object.json.table_items)
                        settableitems(resultAdminSettings.object.json.table_items)
                        setfixedDocSettings(resultAdminSettings.object.json.fixed_docs)
                        localForage.setItem("tableItems", resultAdminSettings.object.json.table_items)
                        dataFetchRights[0] = true;
                    }
                    if(resultAdminSettings.object.json.list_items){
                        if (cancel) return;
                        setlistitems(resultAdminSettings.object.json.list_items)
                        setNewListItems(alldoctypes, resultAdminSettings.object.json.table_items)
                        localForage.setItem("listItems", resultAdminSettings.object.json.list_items)
                    }
                    if(resultAdminSettings.object.json.begeleidend_document){
                        setselectedBdocs(resultAdminSettings.object.json.begeleidend_document)
                    }
                    localForage.setItem("adminSettings", resultAdminSettings.object)
                }
                else {
                    //console.log("Settings are null")
                    handleDoctypesList()
                }
            }
            else {
                //console.log(resultAdminSettings);
            }


            fetch(process.env.REACT_APP_SERVER_LINK+"filetypeGetAll?token="+window.localStorage.getItem("token"), {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                },
            }).then(result => {
                return result.json();
            })
            .then(result => {
                if(result.errorcode === 0){
                    if (cancel) return;
                    setdosright(result.object.filetypes)
                    setredirectRights(false);
                    localForage.setItem("dosRight", result.object.filetypes)
                    //console.log("2 - previous rights set!")
                    setshowMenu(true);
                    setredirectRights(false);
                    setload_rights("success");
                    setTimeout(function(){setload_rights(""); setload_rights("")}, 5000)
                }
                else {
                    console.log(result);
                    //console.log("could not set rights")
                    setload_rights("failed");
                    setTimeout(function(){setload_rights(""); setload_rights("")}, 5000)
                }
            })
            .catch(e => console.log(e))
            

            fetch(process.env.REACT_APP_SERVER_LINK+"usersAll?token="+ window.localStorage.getItem("token"), {
                method: "GET",
                headers: {
                    "Content-Type": "application/json"
                },
            }).then(result => {
                return result.json()
            }).then(
                json => {
                    if(json.errorcode === 0){

                        if (cancel) return;
                        setusers(json.object);
                        setusers_main(json.object)
                        setload_users("success");
                        localForage.setItem("users", json.object);
                        setTimeout(function(){setload_users("")}, 5000)
                    }
                    else{
                        console.log(json);
                        setload_users("failed");
                        setTimeout(function(){setload_users("")}, 5000)
                    }
                }
            )


            fetch(process.env.REACT_APP_SERVER_LINK+"rolesGetAll?token="+window.localStorage.getItem("token"), {
                method: "GET",
                headers: {
                    "Content-Type": "application/json"
                },
            }).then(result => {
                return result.json()
            })
            .then(json =>{
                if (cancel) return;
                setroles(json.object)
                localForage.setItem("roles", json.object)
                let tmproles_labels = [...roles_labels]
                if(json.object){
                    for (let i = 0; i < json.object.length; i++) {
                        tmproles_labels[i] = json.object[i].role 
                    }
                    setroles_labels(tmproles_labels)
                    localForage.setItem("rolesLabels", tmproles_labels);
                    dataFetchRights[3] = true;
                }
                
            })
            .catch(e => 
                console.log(e)
            );
            
        }

        fetching();
         
        const getData = async () =>{
            let dostype = await localForage.getItem("dossierTypes");
            if (cancel) return;
            if(!dostype){
                //socket.emit("dossierTypes");
            }else{
                dataFetchRights[2] = true;   
                setdostypes(dostype)
            }  

            let doctypes = alldoctypes
            if (cancel) return;
            if(doctypes){
                setdoctypes(doctypes)
            }
            else {
                handleDoctypesList();
            }

            if(await localForage.getItem("user_data")){         
                let user_data = JSON.parse(await localForage.getItem("user_data"));
                if(user_data.user.right.portalsettings === true){
                    if (cancel) return;
                    setview_portalsettings(true)
                }
            }
        }

        getData()
        
        return () => { 
            cancel = true;
        }
    }, [])

    const setNewListItems = (a, b) => {
        let newArr = [];

        for (let i = 0; i < a.length; i++) {
            if(!b.includes(a[i].doctype.toString().toUpperCase())){
                newArr.push(a[i].doctype.toString().toUpperCase())
            }
        }

        setlistitems(newArr);
    }

    const handleGetUsers = () =>{
        fetch(process.env.REACT_APP_SERVER_LINK+"usersAll?token="+ window.localStorage.getItem("token"), {
                method: "GET",
                headers: {
                    "Content-Type": "application/json"
                },
            }).then(result => {
                return result.json()
            }).then(
                json => {
                    if(json.errorcode === 0){
                        setusers(json.object);
                        setusers_main(json.object)
                        setload_users("success");
                        localForage.setItem("users", json.object);
                        setTimeout(function(){setload_users("")}, 5000)
                    }
                    else{
                        console.log(json);
                        setload_users("failed");
                        setTimeout(function(){setload_users("")}, 5000)
                    }
                }
            )
    }

    const [edituser, setedituser] = useState({});

    const getFullRole = (role) =>{

        const r = lodash.uniqWith(role.split(';'), lodash.isEqual).map(role => roles?.find(r => r.id.toString() === role.toString())?.role || role)
        return r.join(', ')
    }

    const handleClickResetRights = () =>{
        var resp = window.prompt("Are you sure you want to reset all rights? (type: yes)");
        if(resp === "yes"){
        if(dostypes && doctypes){
            let rightsArray = []

            for (let i = 0; i < dostypes.length; i++) {
                let object = {};
                object.filetype = dostypes[i].dossiertypeid;
                
                let docTypesArray = [];

                for (let j = 0; j < tableitems.length; j++) {
                    let docTypeObject = {};
                    docTypeObject.doctype = tableitems[j];

                    let tmp_roles = [...roles];
                    let usersArray = []
                    for (let k = 0; k < tmp_roles.length; k++) {
                        usersArray = usersArray.concat(tmp_roles[k].id)
                    }
                    docTypeObject.users = usersArray;
                    docTypesArray = docTypesArray.concat(docTypeObject);
                }
                
                object.doctypes = docTypesArray;     

                rightsArray.push(object);
            }

            console.log("reset rights")
            setdosrights(rightsArray);
            let rightsObject = {
                "filetypes": [],
            }
            rightsObject.filetypes = rightsArray;
            let dataRightsObject = {
                "token": window.localStorage.getItem("token"),
                "data": rightsObject
            }
            fetch(process.env.REACT_APP_SERVER_LINK+"filetypeAddSettings", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(dataRightsObject),
            }).then(
                res => res.json()
            ).then(
                json => console.log(json)
            )
        }
        }
    }

    const handleClickEdit = (e) =>{
        for (let i = 0; i < users.length; i++) {
            if(users[i].apiuserid.toString() ===  e.currentTarget.id.toString()){
                setedituser(users[i])
            } 
        }
    }
    
    const handleDeleteUser = (user) =>{
        fetch(process.env.REACT_APP_SERVER_LINK+"userDelete?token="+JSON.parse(window.sessionStorage.getItem("user_data")).token+"&user="+user, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json'
            },
        }).then(
            res => res.json()
        ).then(
            json => {
                if(json.errorcode === 0){
                    setshowWarningDeleteUser(false);
                    setname_todelete("");
                    setid_todelete(null)
                    handleGetUsers()
                }
                else{
                    console.log(json);
                }
            }
        )
    }

    const handleClickDeleteUser = (e) =>{
        
        if(!showWarningDeleteUser){
            setshowWarningDeleteUser(true)
            setid_todelete(e.currentTarget.id)
            setname_todelete(e.currentTarget.name)

            return;
        }
        else{
            let deleteData = {
                "user": id_todelete,
                "token": window.localStorage.getItem("token")
            }
            handleDeleteUser(id_todelete)
        }
    }

    const handleResendEmail = (user) =>{
        fetch(process.env.REACT_APP_SERVER_LINK+"registrationResend?token="+JSON.parse(window.sessionStorage.getItem("user_data")).token+"&user="+user, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            },
        }).then(
            res => res.json()
        ).then(
            json => {
                if(json.errorcode === 0){
                    setsendMailStatus(2);
                }
                else{
                    setsendMailStatus(3)
                    //console.log(data);
                }
                setTimeout(function(){
                    setsendMailStatus(0)
                }, 1500)
            }
        )
    }

    const handleClickSendMail = (e) =>{
        handleResendEmail(e.currentTarget.id);
        setsendMailStatus(1);
    }

    const handleChangeRights = (e, roleId="") =>{
        if(!roleId){ return; }

        const parentId = e.currentTarget.parentNode.parentNode.id.split("_");
        const dossierTypeId = parentId[1].toString();
        const docType = parentId[2].toString();

        let tmp_dosrights = [...dosrights]
        for (let i = 0; i < tmp_dosrights.length; i++) {
            if(tmp_dosrights[i].filetype === parseFloat(dossierTypeId)){
                for (let j = 0; j < tmp_dosrights[i].doctypes.length; j++) {
                    if(tmp_dosrights[i].doctypes[j].doctype === docType){
                        if(tmp_dosrights[i].doctypes[j].users.includes(parseFloat(roleId))){
                            //User verwijderen
                            const index = tmp_dosrights[i].doctypes[j].users.indexOf(parseFloat(roleId));
                            if (index > -1) {
                                tmp_dosrights[i].doctypes[j].users.splice(index, 1);
                            }
                        }
                        else {
                            //User toevoegen`
                            tmp_dosrights[i].doctypes[j].users = tmp_dosrights[i].doctypes[j].users.concat(parseFloat(roleId));
                        }
                    }      
                }
            }
        }

        console.log("a")

        setdosrights(tmp_dosrights);
        localForage.setItem("dosRight", tmp_dosrights);

        let rightsObject = {
            "filetypes": [],
        }
        rightsObject.filetypes = tmp_dosrights

        let dataRightsObject = {
            "token": window.localStorage.getItem("token"),
            "data": rightsObject
        }

        console.log("saving settings... wait")
        console.log(rightsObject);

        //TODO SAVE SETTINGS
        fetch(process.env.REACT_APP_SERVER_LINK+"filetypeAddSettings", {
        	method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(dataRightsObject),
        }).then(
            res => res.json()
        ).then(
            json => console.log(json)
        )

    }

    const handleClickAddItems = () =>{
        
        let tmp_selected = [...selectedDoctypes];
        let tmp_listitems = [...listitems];
        let tmp_tableitems = [...tableitems];

        if(tmp_tableitems[0] === null){
            tmp_tableitems = []
        }

        for (let j = 0; j < tmp_selected.length; j++) {
            for (let i = 0; i < tmp_listitems.length; i++) {
                if(tmp_selected[j].value === tmp_listitems[i]){
                    //Add to unavailable
                    tmp_tableitems = tmp_tableitems.concat(tmp_selected[j].value);
                    
                    //Remove from available
                    let indexItem = tmp_listitems.indexOf(tmp_selected[j].value);
                    if(indexItem > -1){
                        tmp_listitems.splice(indexItem, 1);
                    }
                }  
            }            
        }

        setclearDoctypesDdl(true);
        //SAVE TABLE SETTINGS
        let tmp_adminSettings = {...adminSettings}
        if(typeof(tmp_adminSettings.json) === 'string' || tmp_adminSettings.json === null || tmp_adminSettings.json === undefined){
            tmp_adminSettings = {}
            tmp_adminSettings.json = {};
            tmp_adminSettings.json.table_items = [];
            tmp_adminSettings.json.list_items = [];
        }

        tmp_adminSettings.json.table_items = tmp_tableitems.sort();
        tmp_adminSettings.json.list_items = tmp_listitems.sort();
        setadminSettings(tmp_adminSettings);
        setfixedDocSettings(tmp_adminSettings.json.fixed_docs)
        setlistitems(tmp_listitems.sort());
        setNewListItems(alldoctypes, tmp_tableitems.sort())
        settableitems(tmp_tableitems.sort());
        setredirectRights(false);

        //SETRIGHTS
        let tmp_dosrights = [...dosrights]
        //{doctype: 'AFAC', users: Array(4)}
        for (let j = 0; j < tmp_selected.length; j++) {
            for (let i = 0; i < tmp_dosrights.length; i++) {
                let object = {};
                object.users = ['1'];
                object.doctype = tmp_selected[j].value;
                tmp_dosrights[i].doctypes = tmp_dosrights[i].doctypes.concat(object);
            }
        }
        
        for (let i = 0; i < tmp_dosrights.length; i++) {
            tmp_dosrights[i].doctypes = tmp_dosrights[i].doctypes.sort((a, b) => a.doctype.localeCompare(b.doctype)) 
        }

        console.log("a")

        setdosrights(tmp_dosrights);

        const adminSettingsData = {
            "token": window.localStorage.getItem("token"),
            "data": tmp_adminSettings
        }

        fetch(process.env.REACT_APP_SERVER_LINK+"adminSettingsUpdate?token="+adminSettingsData.token, {
        	method: "PUT",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(adminSettingsData.data),
        })

        let rightsObject = {
            "filetypes": [],
        }
        rightsObject.filetypes = tmp_dosrights

        let dataRightsObject = {
            "token": window.localStorage.getItem("token"),
            "data": rightsObject
        }

        fetch(process.env.REACT_APP_SERVER_LINK+"filetypeAddSettings", {
        	method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(dataRightsObject),
        }).then(
            res => res.json()
        ).then(
            json => console.log(json)
        )
    }

    useEffect(()=>{
        setTimeout(function(){setclearDoctypesDdl(false)}, 500)
    }, [clearDoctypesDdl])

    const handleClickDeleteDoctype = (e) =>{
        let tmp_selected = e.currentTarget.name
        let tmp_listitems = [...listitems];
        let tmp_tableitems = [...tableitems];

        //Remove from table items
        let indexItem = tmp_tableitems.indexOf(tmp_selected);
        if(indexItem > -1){
            tmp_tableitems.splice(indexItem, 1);
        }

        //Add to available
        tmp_listitems = tmp_listitems.concat(tmp_selected);   

        //SAVE TABLE SETTINGS
        let tmp_adminSettings = {...adminSettings}
        if(tmp_adminSettings.json){
            tmp_adminSettings.json.table_items = tmp_tableitems.sort();
            tmp_adminSettings.json.list_items = tmp_listitems.sort();
            setadminSettings(tmp_adminSettings);
            setfixedDocSettings(tmp_adminSettings.json.fixed_docs)
            setlistitems(tmp_listitems.sort());
            settableitems(tmp_tableitems.sort());
            setNewListItems(alldoctypes, tmp_tableitems.sort())
            //SETRIGHTS
            const adminSettingsData = {
                "token": window.localStorage.getItem("token"),
                "data": tmp_adminSettings
            }
            //socket.emit("adminSettingsUpdate", adminSettingsData)
            fetch(process.env.REACT_APP_SERVER_LINK+"adminSettingsUpdate?token="+adminSettingsData.token, {
                method: "PUT",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(adminSettingsData.data),
            }).then(
                json => json.json()
            ).then(
                json => {
                    console.log(json)
                }
            )
        }
        
    }

    const checkRights = () => {
        return fetch(process.env.REACT_APP_SERVER_LINK+"filetypeGetAll?token="+window.localStorage.getItem("token"), {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                },
            }).then(result => {
                return result.json();
            })
            .then(result => {
                if(result.errorcode === 0){
                    setdosright(result.object.filetypes)
                    setredirectRights(false);
                    localForage.setItem("dosRight", result.object.filetypes)
                    //console.log("2 - previous rights set!")
                    setshowMenu(true);
                    setredirectRights(false);
                    setload_rights("success");
                    setTimeout(function(){setload_rights(""); setload_rights("")}, 5000)
                    return true
                }
                else {
                    console.log(result);
                    //console.log("could not set rights")
                    setload_rights("failed");
                    setTimeout(function(){setload_rights(""); setload_rights("")}, 5000)
                    return false;
                }
            })
            .catch(e => {console.log(e); return false})
    }

    const handleViewRights = () =>{
        if(dosrights && !redirectRights){
            if(dosrights.length > 0){
                setselectedSubpage("Rechten");
            }
            else {
                if(!checkRights){
                    setselectedSubpage("Rechten_Instellingen")
                }
                else{
                    setselectedSubpage("Rechten");
                }

                
            }
        }     
        else{
            if(!checkRights){
                setselectedSubpage("Rechten_Instellingen")
            }
            else{
                setselectedSubpage("Rechten");
            }
        }
    }

    const handleFilterSearch = (users, search) =>{
        let filteredUsers = []
        for (let i = 0; i < users.length; i++) {
            if((users[i].username).includes(search) || ((users[i].relnr).toString()).includes(search) || ((users[i].firstname).toString().toLowerCase()).includes(search.toLowerCase()) || ((users[i].lastname).toString().toLowerCase()).includes(search.toLowerCase())){
                filteredUsers = filteredUsers.concat(users[i])
            }            
        }
        return filteredUsers;
    }

    const handleFilterNewest = (users) =>{
        let tmp_users = users.sort(function(a,b){
            return new Date(a.datecreated) - new Date(b.datecreated);
        });
        return tmp_users.reverse();
    }

    const handleFilterOldest = (users) =>{
        let tmp_users = users.sort(function(a,b){
            return new Date(a.datecreated) - new Date(b.datecreated);
        });
        return tmp_users;
    }

    const handleFilterLanguage = (users) =>{
        let tmp_users = users.sort(function(a, b) {
            var textA = a.language.toUpperCase();
            var textB = b.language.toUpperCase();
            return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
        });
        return tmp_users;
    }

    const handleFilterLastname = (users) =>{
        let tmp_users = users.sort(function(a, b) {
            var textA = a.lastname.toUpperCase();
            var textB = b.lastname.toUpperCase();
            return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
        });
        return tmp_users;
    }

    const handleFilterFirstname = (users) =>{
        let tmp_users = users.sort(function(a, b) {
            var textA = a.firstname.toUpperCase();
            var textB = b.firstname.toUpperCase();
            return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
        });
        return tmp_users;
    }

    const handleFilterRole = (users) =>{
        let tmp_users = users.sort(function(a,b){
            return parseFloat(a.role) - parseFloat(b.role);
        });
        return tmp_users;
    }

    const handleFilterEmail = (users) =>{
        let tmp_users = users.sort(function(a, b) {
            var textA = a.username.toUpperCase();
            var textB = b.username.toUpperCase();
            return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
        });
        return tmp_users;
    }

    const handleFilterName = (users, value) =>{
        let tmp_users = []
        for (let i = 0; i < users.length; i++) {
            if(((users[i].firstname).toUpperCase()).includes(value.toUpperCase()) || ((users[i].lastname).toUpperCase()).includes(value.toUpperCase())){
                tmp_users = tmp_users.concat(users[i])
            }
        }
        return tmp_users;
    }

    const handleFilterRoles = (users, selectedRoles) =>{
        if(roles){
        let selectedRoleIds = [];

        let selRoles = Object.keys(selectedRoles.role)
        for (let i = 0; i < roles.length; i++) {
            for (let j = 0; j < selRoles.length; j++) {
                if(roles[i].role === selRoles[j]){
                    selectedRoleIds = selectedRoleIds.concat(roles[i].id)
                }
            }
        }

        let tmp_users = []
        for (let i = 0; i < users.length; i++) {
            if(!selectedRoleIds.includes(parseFloat(users[i].role))){
                tmp_users = tmp_users.concat(users[i])
            }
        }
        return tmp_users;
        }
        else{
            return users;
        }
        
    }

    const handlePickLanguage = (users, selectedLanguages) =>{
        let selectedLanguagesLetters = [];

        let languages = Object.keys(selectedLanguages.language);
        for (let i = 0; i < languages.length; i++) {
            languages[i] = languages[i].charAt(0).toUpperCase()
        }

        let tmp_users = []
        for (let i = 0; i < users.length; i++) {
            if(languages.includes(users[i].language) === false){
                tmp_users = tmp_users.concat(users[i])
            }
        }

        return tmp_users;
    }

    const handleFilterVerified = (users, selectedVerified) =>{
        let tmp_users = [];
        if(selectedVerified === "all"){
            return users;
        }
        else if(selectedVerified === "geverifieerd"){
            for (let i = 0; i < users.length; i++) {
                if(users[i].verified){
                    tmp_users = tmp_users.concat(users[i])
                }
            }
        }
        else if(selectedVerified === "niet geverifieerd"){
            for (let i = 0; i < users.length; i++) {
                if(!users[i].verified){
                    tmp_users = tmp_users.concat(users[i])
                }
            }
        }

        return tmp_users;
    }

    const [showFilter, setshowFilter] = useState(false);

    let search_value = "";
    const [filter_search, setfilter_search] = useState("");
    const [filter_sorting, setfilter_sorting] = useState("Oudste eerst");
    const [filter_role, setfilter_role] = useState({"role":{}});
    const [filter_name, setfilter_name] = useState("");
    const [filter_language, setfilter_language] = useState({"language":{}});
    const [filter_verified, setfilter_verified] = useState("all");

    const onFilter = (usr) => {
        
        let users = Array.isArray(usr) ? [...usr] : [...users_main];

        let combinedFilters = [];

        //Search
        let filtered_search = []
        if(filter_search.length >= filtered_search){filtered_search = handleFilterSearch(users, filter_search);}
        else{filtered_search = handleFilterSearch(users, search_value);}
        combinedFilters = combinedFilters.concat([filtered_search]);

            
        //Rol (checkbox)
        let filtered_roles = handleFilterRoles(users, filter_role)
        combinedFilters = combinedFilters.concat([filtered_roles]);

        //Naam
        let filtered_name = handleFilterName(users, filter_name)
        combinedFilters = combinedFilters.concat([filtered_name]);

        //Taal 
        let filtered_language = handlePickLanguage(users, filter_language)
        combinedFilters = combinedFilters.concat([filtered_language]);

        //Status
        let filtered_verified = handleFilterVerified(users, filter_verified);
        combinedFilters = combinedFilters.concat([filtered_verified]);
            //Geverifieerd
            //Niet geverifieerd

        let finalArray = commonElementsOfArray(combinedFilters);

        //Sorteren
        let filtered_sort = [];
        if(filter_sorting === "E-mailadres"){
            //Op email
            filtered_sort = handleFilterEmail(finalArray);
        }
        else if(filter_sorting === "Rol"){
            //Op rol
            filtered_sort = handleFilterRole(finalArray);
        }    
        else if(filter_sorting === "Voornaam"){
            //Op voornaam
            filtered_sort = handleFilterFirstname(finalArray);
        }
        else if(filter_sorting === "Familienaam"){
            //Op Familienaam
            filtered_sort = handleFilterLastname(finalArray);
        }
        else if(filter_sorting === "Taal"){
            //Op Taal
            filtered_sort = handleFilterLanguage(finalArray);
        }
        else if(filter_sorting === "Nieuwste eerst"){
            //Op Nieuwste eerst
            filtered_sort = handleFilterNewest(finalArray)
        }
        else if(filter_sorting === "Oudste eerst"){
            //Op Oudste eerst
            filtered_sort = handleFilterOldest(finalArray)
        }

        finalArray = filtered_sort;

        // setusers(finalArray);
        return finalArray
    }

    const commonElementsOfArray = (arrays) => {
        var result = arrays.shift().filter(function(v) {
            return arrays.every(function(a) {
                return a.indexOf(v) !== -1;
            });
        });

        return result;
    }

    const handleSearch = (e) =>{
        setfilter_search(e.currentTarget.value)
        search_value = e.currentTarget.value;
    }

    const handleUserUpdate = (data) =>{
        fetch(process.env.REACT_APP_SERVER_LINK+"userUpdate", {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
        }).then(
            res => res.json()
        ).then(
            json => {
                if(json.errorcode === 0){
                    setupdateStatus("updated");

                    setTimeout(function(){setupdateStatus("standard")}, 1500)
                }
                else{
                    setupdateStatus("failed");
                    console.log(json);
                }
            }
        )         
    }

    const handleUserDelete = (data) =>{
        fetch(process.env.REACT_APP_SERVER_LINK+"userDelete?token="+data.token+"&user="+data.user, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json'
            },
        }).then(
            res => res.json()
        ).then(
            json => {
                if(json.errorcode === 0){
                    setshowWarningDeleteUser(false);
                    setname_todelete("");
                    setid_todelete(null)
                    handleGetUsersAll()
                }
                else{
                    console.log(json);
                }
            }
        )
    }

    const handleGetUsersAll = (token) =>{
        fetch(process.env.REACT_APP_SERVER_LINK+"usersAll?token="+token, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            },
        }).then(
            res => res.json()
        ).then(
            json => {
                if(json.errorcode === 0){
                    setusers(json.object);

                    setusers_main(json.object)
                }
            }
        )
    }

    const handleFiletypeAddSettings = (dataRightsObject) =>{
        fetch(process.env.REACT_APP_SERVER_LINK+"adminSettingsUpdate?token="+dataRightsObject.token, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(dataRightsObject.data)
        }).then(
            res => res.json()
        ).then(

        )
    }

    const handleDoctypesList = () =>{ 
        //Fitdoc token
        fetch(process.env.REACT_APP_SERVER_LINK+"doctypesList?token="+getFitDocToken(JSON.parse(window.sessionStorage.getItem("user_data"))), {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            },
        }).then(
            res => res.json()
        ).then(
            result => {
                if(result.object){
                    setdoctypes(result.object)
                    //setshowMenu(true);
                    setredirectRights(true);
                    let tmp_listitems = [];
                    for (let i = 0; i < result.object.length; i++) {
                        tmp_listitems = tmp_listitems.concat(result.object[i].doctype)
                    }
                    setlistitems(tmp_listitems);
                    settableitems([null])
                }
            }
        )
    }

    const [bdocItems, setbdocItems] = useState([])
    const [selectedBdocs, setselectedBdocs] = useState()
    const [showViewDocument, setshowViewDocument] = useState(false);
    const [numPages, setNumPages] = useState(null);
    const [file_base64, setfile_base64] = useState("");
    const [file_docid, setfile_docid] = useState("");
    const [load_document, setload_document] = useState(null)

    useEffect(()=>{
        setbdocItems(JSON.parse(window.localStorage.getItem("bdoc")))
    }, [])

    const handleShowDocument = (id) => {
        setload_document("loading");

        fetch(process.env.REACT_APP_SERVER_LINK+"documents?docid="+id+"&token="+getFitDocToken(JSON.parse(window.sessionStorage.getItem("user_data")))).then(
            res => res.json()
        ).then(
            json => {
                if(json.errorcode === 0){
                    setload_document("success");
                    setfile_base64(json.object.file);
                    setfile_docid(json.object.docid.toString())
                    setshowViewDocument(true)
                }
                else{
                    setload_document("failed");
                }
            })
    }

    const handleGroupidToGroupname = (id) => {
        if(id !== "" && Array.isArray(allgroups)){
            let groupname = "!";
            for (let i = 0; i < allgroups.length; i++) {
                if(allgroups[i].groupid.toString().toLowerCase().replace(/\s/g, '') === id.toString().toLowerCase().replace(/\s/g, '')){
                    groupname = allgroups[i].name
                }
            }
            return groupname;
        }
        else {
            return "!";
        }
    }

    const setLocaleString = (language) =>{
        if(language === "N"){
            return "nl-BE"
        }
        else if(language === "F"){
            return "fr-FR"
        }
        else{
            return "en-GB"
        }
    }

    const yyyymmddToLong = (date) => {
        if(!date){return date}
        return new Date(((date.substring(4, 6)+"-"+date.substring(6, 8)+"-"+date.substring(0, 4)).toString())).toLocaleString(setLocaleString(ReactSession.get("language")), { day:"numeric", month: 'long',year:"numeric" })
    }

    const nfuDocs = useSelector((state) => state.nfuDocs)
    const [fixedDocPage, setfixedDocPage] = useState("BEGELEIDDOC");
    const [fixedDocPeriod, setfixedDocPeriod] = useState("Standaard");
    const [fixedDocSettings, setfixedDocSettings] = useState({});

    function formatDate(date) {
        var d = new Date(date),
            month = '' + (d.getMonth() + 1),
            day = '' + d.getDate(),
            year = d.getFullYear();

        if (month.length < 2) 
            month = '0' + month;
        if (day.length < 2) 
            day = '0' + day;

        return [year, month, day].join('');
    }

    const [clearDateRange, setclearDateRange] = useState(false);

    useEffect(() => {if(clearDateRange){setclearDateRange(false)}}, [clearDateRange])

    const handleAddBDOCPeriod = (dates) => {
        let tmp_fixedDocSettings = {...fixedDocSettings};
        let dateString = formatDate(dates[0].startDate)+"-"+formatDate(dates[0].endDate);
        tmp_fixedDocSettings.BEGELEIDDOC[dateString] = "";
        setfixedDocSettings(tmp_fixedDocSettings);
        setclearDateRange(true);
    }

    const handleAddNFUPeriod = (dates) => {
        let tmp_fixedDocSettings = {...fixedDocSettings};
        let dateString = formatDate(dates[0].startDate)+"-"+formatDate(dates[0].endDate);
        tmp_fixedDocSettings.NFU[dateString] = "";
        setfixedDocSettings(tmp_fixedDocSettings);
        setclearDateRange(true);
    }

    const [showWarningPickDocument, setshowWarningPickDocument] = useState(null);
    const [showWarningPickNfuDocument, setshowWarningPickNfuDocument] = useState(null);

    const handleClickBdocCard = (bdoc) => {
        setshowWarningPickDocument(bdoc);
    }

    const handleClickNfuCard = (nfu) => {
        setshowWarningPickNfuDocument(nfu);
    }

    const confirmAddPickDocument = () => {
        let tmp_fixedDocSettings = {...fixedDocSettings};
        tmp_fixedDocSettings.BEGELEIDDOC[fixedDocPeriod] = showWarningPickDocument.toString();
        setfixedDocSettings(tmp_fixedDocSettings);
        setshowWarningPickDocument(null);

        //UPDATE DOSSIERS
        let tmp_adminSettings = {...adminSettings};
        tmp_adminSettings.json.fixed_docs.BEGELEIDDOC = tmp_fixedDocSettings.BEGELEIDDOC;
        setadminSettings(tmp_adminSettings)

        //SAVE IN ADMIN SETTINGS
        fetch(process.env.REACT_APP_SERVER_LINK+"adminSettingsUpdate?token="+JSON.parse(window.sessionStorage.getItem("user_data")).token, {
        	method: "PUT",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(tmp_adminSettings),
        })
    }

    const confirmAddPickNfuDocument = () => {
        let tmp_fixedDocSettings = {...fixedDocSettings};
        tmp_fixedDocSettings.NFU[fixedDocPeriod] = showWarningPickNfuDocument.toString();
        setfixedDocSettings(tmp_fixedDocSettings);
        setshowWarningPickNfuDocument(null);

        //UPDATE DOSSIERS
        let tmp_adminSettings = {...adminSettings};
        tmp_adminSettings.json.fixed_docs.NFU = tmp_fixedDocSettings.NFU;
        setadminSettings(tmp_adminSettings)

        //SAVE IN ADMIN SETTINGS
        fetch(process.env.REACT_APP_SERVER_LINK+"adminSettingsUpdate?token="+JSON.parse(window.sessionStorage.getItem("user_data")).token, {
        	method: "PUT",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(tmp_adminSettings),
        })
    }

    const deletePeriodFixedDocs = (type, date) => {
        let tmp_fixedDocSettings = {...fixedDocSettings};
        delete tmp_fixedDocSettings[type][date];
        setfixedDocPeriod("Standaard")
        setfixedDocSettings(tmp_fixedDocSettings)

        //UPDATE DOSSIERS
        let tmp_adminSettings = {...adminSettings};
        tmp_adminSettings.json.fixed_docs[type] = tmp_fixedDocSettings[type];
        setadminSettings(tmp_adminSettings)

        //SAVE IN ADMIN SETTINGS
        fetch(process.env.REACT_APP_SERVER_LINK+"adminSettingsUpdate?token="+JSON.parse(window.sessionStorage.getItem("user_data")).token, {
        	method: "PUT",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(tmp_adminSettings),
        })
    }

    const [showGroupSettings, setshowGroupSettings] = useState(null);

    const [groupData, setgroupData] = useState([]);
    const [groupCurrent, setgroupCurrent] = useState([]);
    const keys = {profile_picture:"name", name_top:"name", name_bottom:"relnr"}

    const allrelations = useSelector(state => state.allRelations)
    const allgroups = useSelector(state => state.allGroups);

    useEffect(()=>{
        if(allgroups){
            if(!Array.isArray(allgroups)){return;}
            let arr = []
            for (let i = 0; i < allgroups.length; i++) {
                arr.push(allgroups[i].groupid+"_"+allgroups[i].name)
            }
            setgroupDropdownData(arr)
        }
    }, [allgroups])

    useEffect(()=>{
        if(Array.isArray(allrelations)){
            let grp = []
            for (let i = 0; i < allrelations.length; i++) {
                let obj = {}
                obj.relnr = allrelations[i].split("_")[0]
                obj.name = allrelations[i].split("_")[1]
                grp.push(obj);
            }
            setgroupData(grp);
        }
    }, [allrelations])

    const dispatch = useDispatch(null);

    const saveGroup = async (arr, name) => {
        if(name === ""){return;}
        if(showGroupSettings.groupid){
            //Existing group
            let obj = {}
            obj.token = JSON.parse(window.sessionStorage.getItem("user_data")).token;
            obj.groupid = showGroupSettings.groupid
            obj.name = name
            let stringRelnrs = [];
            for (let i = 0; i < arr.length; i++) {
                stringRelnrs.push(arr[i].relnr)
            }
            obj.relnr = stringRelnrs.join(";")
            const ug = await handleUpdateGroup(obj);
            if(ug.errorcode === 0){
                console.log("close")
                setshowGroupSettings(null); 
                const ag = await handleGetAllGroups(JSON.parse(window.sessionStorage.getItem("user_data")))
                if(ag.errorcode === 0){dispatch(setAllGroups(ag.object))}
            }
        }
        else {
            //New group
            let obj = {}
            obj.token = JSON.parse(window.sessionStorage.getItem("user_data")).token;
            obj.name = name
            let stringRelnrs = [];
            for (let i = 0; i < arr.length; i++) {
                stringRelnrs.push(arr[i].relnr)
            }
            obj.relnr = stringRelnrs.join(";")
            const ng = await handleCreateGroup(obj);
            if(ng.errorcode === 0){
                console.log("close")
                setshowGroupSettings(null)
                const ag = await handleGetAllGroups(JSON.parse(window.sessionStorage.getItem("user_data")))
                if(ag.errorcode === 0){dispatch(setAllGroups(ag.object))}
            }
        }
    }

    useEffect(()=>{
        if(showGroupSettings){
            if(showGroupSettings.members){
                let arr = []
                for (let i = 0; i < showGroupSettings.members.length; i++) {
                    let obj = {}
                    obj.relnr = showGroupSettings.members[i].toString()
                    obj.name = convertRelationRelnrToName(showGroupSettings.members[i].toString(), allrelations).split("_")[1]
                    arr.push(obj)
                }
                setgroupCurrent(arr)
            }
        }
    }, [showGroupSettings])

    const reloadDossierSettings = async () => {
        try {
            toast.loading('Volledigheid dossiers checken...', { id:'reloadDossierSettings', position:'bottom-right' })
            let resp = await fetch(process.env.REACT_APP_SERVER_LINK+"updateFileStatus");
            let data = await resp.json();
            if(data.errorcode === 0) { toast.success('Volledigheid dossiers gecheckt!', { id:'reloadDossierSettings' }) }
            else { toast.error('Volledigheid dossiers checken mislukt', { id:'reloadDossierSettings' }) }
            console.log(data);
            
        } catch (error) {
            console.log(error);
            toast.error('Volledigheid dossiers checken mislukt', { id:'reloadDossierSettings' })
        }
    }

	return (
	    <>	
        <Toaster />
        <LoadingContainer hide={false}>
            {load_users && <LoadingStatus message={content_state[ReactSession.get("language")] ? (content_state[ReactSession.get("language")].UserManagement && content_state[ReactSession.get("language")].UserManagement.loading_gettingusers && content_state[ReactSession.get("language")].UserManagement.loading_gettingusers) : "Getting users..."} loadingIcon status={load_users}/>}
            {load_rights && <LoadingStatus message={content_state[ReactSession.get("language")] ? (content_state[ReactSession.get("language")].UserManagement && content_state[ReactSession.get("language")].UserManagement.loading_setrights && content_state[ReactSession.get("language")].UserManagement.loading_setrights) : "Setting rights..."} loadingIcon status={load_rights}/>}
            {load_document && <LoadingStatus onClose={()=>{setload_document(null)}} message={load_document ==="loading" ? "Document openen..." : load_document === "failed" ? "Kon document niet openen" : "Document geopend"} loadingIcon status="loading"/>}
        </LoadingContainer>

        {showGroupSettings && 
        <>
            <GroupsPopup onClose={()=>{if(showGroupSettings){console.log("close"); setshowGroupSettings(null)}}} group={showGroupSettings} onSave={(arr, name)=>{saveGroup(arr, name)}} data={groupData} crntGrp={groupCurrent} keys={keys} placeholder="Relaties toevoegen"/>
        </>
        }

        {showWarningPickDocument && 
        <div className={style.warning_background}>
            <div className={style.warning_container}>
                <p className={style.warning_title}>Document kiezen</p>
                <p>Bent u zeker dit document te kiezen: <span style={{fontWeight:"bold"}}>{(bdocItems.find(item => item.docid === showWarningPickDocument)).filename}</span> 
                <br></br><br></br>       
                Voor volgende periode: {yyyymmddToLong(fixedDocPeriod.split("-")[1]) ? <span style={{fontWeight:"bold"}}>{yyyymmddToLong(fixedDocPeriod.split("-")[0]) + " - " + yyyymmddToLong(fixedDocPeriod.split("-")[1])}</span> : <span style={{fontWeight:"bold"}}>Standaard</span>}</p>
                <p>U kan deze actie niet ongedaan maken</p>
                <div className={style.warning_consequence_container}>
                    <p className={style.warning_consequence_title}>Waarschuwing</p>
                    <p className={style.warning_consequence_description}>Dit document wordt aan alle substraat dossiers toegevoegd waar geen begeleidend document te vinden is.</p>
                </div>
                <div className={style.warning_buttons}>
                    <button onClick={()=>{setshowWarningPickDocument(null)}} className={style.warning_button_cancel}>Annuleren</button>
                    <button onClick={()=>{confirmAddPickDocument()}} className={style.warning_button_confirm}>Kies document</button>
                </div>
                
            </div>
        </div>
        }

        {showWarningPickNfuDocument && 
        <div className={style.warning_background}>
            <div className={style.warning_container}>
                <p className={style.warning_title}>Document kiezen</p>
                <p>Bent u zeker dit document te kiezen: <span style={{fontWeight:"bold"}}>{(nfuDocs.find(item => item.docid === showWarningPickNfuDocument)).filename}</span> <br></br><br></br>
                Voor volgende periode: {yyyymmddToLong(fixedDocPeriod.split("-")[1]) ? <span style={{fontWeight:"bold"}}>{yyyymmddToLong(fixedDocPeriod.split("-")[0]) + " - " + yyyymmddToLong(fixedDocPeriod.split("-")[1])}</span> : <span style={{fontWeight:"bold"}}>Standaard</span>}</p>                <p>U kan deze actie niet ongedaan maken</p>
                <div className={style.warning_consequence_container}>
                    <p className={style.warning_consequence_title}>Waarschuwing</p>
                    <p className={style.warning_consequence_description}>Dit document wordt aan alle substraat dossiers toegevoegd waar geen NFU document te vinden is.</p>
                </div>
                <div className={style.warning_buttons}>
                    <button onClick={()=>{setshowWarningPickNfuDocument(null)}} className={style.warning_button_cancel}>Annuleren</button>
                    <button onClick={()=>{confirmAddPickNfuDocument()}} className={style.warning_button_confirm}>Kies document</button>
                </div>
                
            </div>
        </div>
        }
        
        {showWarningDeleteUser &&
        <div className={style.warning_background}>
            <div className={style.warning_container}>
                <p className={style.warning_title}>{content_state[ReactSession.get("language")] ? (content_state[ReactSession.get("language")].UserManagement && content_state[ReactSession.get("language")].UserManagement.warning_title && content_state[ReactSession.get("language")].UserManagement.warning_title) : "Delete user"}?</p>
                <p>{content_state[ReactSession.get("language")] ? (content_state[ReactSession.get("language")].UserManagement && content_state[ReactSession.get("language")].UserManagement.warning_subtitle_one && content_state[ReactSession.get("language")].UserManagement.warning_subtitle_one) : "Are you sure you want to delete "} <span style={{fontWeight:"bold"}}>"{name_todelete}"</span>?</p>
                <p>{content_state[ReactSession.get("language")] ? (content_state[ReactSession.get("language")].UserManagement && content_state[ReactSession.get("language")].UserManagement.warning_subtitle_two && content_state[ReactSession.get("language")].UserManagement.warning_subtitle_two) : "You can't undo this action."}</p>
                <div className={style.warning_consequence_container}>
                    <p className={style.warning_consequence_title}>{content_state[ReactSession.get("language")] ? (content_state[ReactSession.get("language")].UserManagement && content_state[ReactSession.get("language")].UserManagement.warning_consequence_title && content_state[ReactSession.get("language")].UserManagement.warning_consequence_title) : "Warning"}</p>
                    <p className={style.warning_consequence_description}>{content_state[ReactSession.get("language")] ? (content_state[ReactSession.get("language")].UserManagement && content_state[ReactSession.get("language")].UserManagement.warning_consequence_description && content_state[ReactSession.get("language")].UserManagement.warning_consequence_description) : "If you delete this user, he will not be able to login to the portal again"}</p>
                </div>
                <div className={style.warning_buttons}>
                    <button onClick={()=>{setshowWarningDeleteUser(false)}} className={style.warning_button_cancel}>{content_state[ReactSession.get("language")] ? (content_state[ReactSession.get("language")].UserManagement && content_state[ReactSession.get("language")].UserManagement.warning_cancel && content_state[ReactSession.get("language")].UserManagement.warning_cancel) : "Cancel"}</button>
                    <button onClick={()=>{handleClickDeleteUser()}} className={style.warning_button_confirm}>{content_state[ReactSession.get("language")] ? (content_state[ReactSession.get("language")].UserManagement && content_state[ReactSession.get("language")].UserManagement.warning_confirm && content_state[ReactSession.get("language")].UserManagement.warning_confirm) : "Delete user"} <img src={bin_icon_white} alt="delete icon"/></button>
                </div>
                
            </div>
        </div>
        }

        {showViewDocument && 
        <div className={style.warning_background}>
            <div className={style.viewdoc_container}>
                    <div className={styles.document_preview_header}>
                        <button onClick={()=>{setshowViewDocument(false); setfile_base64(""); setfile_docid("")}}><img src={backarrow_icon_white} alt="icon"/><p>{content_state[ReactSession.get("language")] ? (content_state[ReactSession.get("language")].Documents && content_state[ReactSession.get("language")].Documents.labelpreview_back && content_state[ReactSession.get("language")].Documents.labelpreview_back) : "Back"}</p></button>
                        <h2 className={styles.document_preview_title}>{file_docid ? "Document - " + file_docid : "Loading..."}</h2>
                    </div>
                    <div className={styles.pdf_viewer}>
                        <Document
                        onLoadSuccess={({ numPages })=>setNumPages(numPages)}
                        file={"data:application/pdf;base64,"+file_base64}
                        >
                            {Array.apply(null, Array(numPages))
                            .map((x, i)=>i+1)
                            .map(page => <div key={page} style={{marginBottom:"1.5rem"}}><Page pageNumber={page}/></div>)}
                            
                        </Document>
                    </div>
            </div>
        </div>
        }

        <p className={styles.title}>{content_state[ReactSession.get("language")] ? (content_state[ReactSession.get("language")].UserManagement && content_state[ReactSession.get("language")].UserManagement.title && content_state[ReactSession.get("language")].UserManagement.title) : "User management"}</p>
        <div>
            <div className={style.navigation_container}>
                <button onClick={()=>{setselectedSubpage("Overzicht"); handleGetUsersAll(window.localStorage.getItem("token"));}} className={selectedSubpage === "Overzicht" ? style.navigation_button_active : style.navigation_button}>{content_state[ReactSession.get("language")] ? (content_state[ReactSession.get("language")].UserManagement && content_state[ReactSession.get("language")].UserManagement.overview_button && content_state[ReactSession.get("language")].UserManagement.overview_button) : "Overview"}</button>
                <button onClick={()=>{setselectedSubpage("Usergroups");}} className={selectedSubpage === "Usergroups" ? style.navigation_button_active : style.navigation_button}>Gebruikersgroepen</button>
                <button onClick={()=>{setselectedSubpage("Toevoegen")}} className={selectedSubpage === "Toevoegen" ? style.navigation_button_active : style.navigation_button}>{content_state[ReactSession.get("language")] ? (content_state[ReactSession.get("language")].UserManagement && content_state[ReactSession.get("language")].UserManagement.adduser_button && content_state[ReactSession.get("language")].UserManagement.adduser_button) : "Add user"}</button>
                {(showMenu) && <button onClick={()=>{handleViewRights()}} className={selectedSubpage === "Rechten" ? style.navigation_button_active : style.navigation_button}>{content_state[ReactSession.get("language")] ? (content_state[ReactSession.get("language")].UserManagement && content_state[ReactSession.get("language")].UserManagement.rights_button && content_state[ReactSession.get("language")].UserManagement.rights_button) : "Rights"}</button>}
                {selectedSubpage === "Detail" && <button className={selectedSubpage === "Detail" ? style.navigation_button_active_hidden : style.navigation_button}>{content_state[ReactSession.get("language")] ? (content_state[ReactSession.get("language")].UserManagement && content_state[ReactSession.get("language")].UserManagement.detailview_button && content_state[ReactSession.get("language")].UserManagement.detailview_button) : "Detail view"}</button>}
                {selectedSubpage === "Rechten_Instellingen" && <button className={selectedSubpage === "Rechten_Instellingen" ? style.navigation_button_active_hidden : style.navigation_button}>{content_state[ReactSession.get("language")] ? (content_state[ReactSession.get("language")].UserManagement && content_state[ReactSession.get("language")].UserManagement.rights_doctype_settings && content_state[ReactSession.get("language")].UserManagement.rights_doctype_settings) : "Document type settings"}</button>}
                <button onClick={()=>{setselectedSubpage("Volledigheid");}} className={selectedSubpage === "Volledigheid" ? style.navigation_button_active : style.navigation_button}>Volledigheid</button>
                {bdocItems && Array.isArray(bdocItems) && bdocItems.length > 0 && <button onClick={()=>{setselectedSubpage("Begeleidend document")}} className={selectedSubpage === "Begeleidend document" ? style.navigation_button_active : style.navigation_button}>Vaste documenten</button>}
            </div>

            {selectedSubpage === "Overzicht" ? 
            <div className={style.sub_content}>
                
                <div className={styles.filter_header}>
                    <div>
                        <Input value={filter_search} onChange={(e)=>{handleSearch(e)}} placeholder={content_state[ReactSession.get("language")] ? (content_state[ReactSession.get("language")].UserManagement && content_state[ReactSession.get("language")].UserManagement.placeholder_search && content_state[ReactSession.get("language")].UserManagement.placeholder_search) : "Search..."}/>
                    </div>
                    {/* <div className={styles.filter_search}><img className={styles.filter_search_image} src={search_icon} alt="search icon"/><input onChange={(e)=>{handleSearch(e)}} className={styles.filter_search_input} type="text" placeholder={content_state[ReactSession.get("language")] ? (content_state[ReactSession.get("language")].UserManagement && content_state[ReactSession.get("language")].UserManagement.placeholder_search && content_state[ReactSession.get("language")].UserManagement.placeholder_search) : "Search..."}/></div> */}
                    <div className={styles.dropdown_content}>       
                        <button name="filter_button" onClick={()=>setshowFilter(!showFilter)} className={`w-10 h-10 flex border border-solid border-input justify-center items-center text-neutral-400`}>{!showFilter ? <FilterIcon className="w-4 h-4"/> : <XIcon className="w-4 h-4"/>}</button>
                        {showFilter && <Filter onOutsideClick={(value)=>{setshowFilter(value)}} content_state={content_state} onChangeFilterVerified={(value)=>{setfilter_verified(value); onFilter()}} filter_verified={filter_verified} filter_language={filter_language} onChangeFilterLanguage={(value)=>{setfilter_language(value); onFilter()}} onChangeFilterRole={(value)=>{setfilter_role(value); onFilter()}} filter_role={filter_role} onChangeSorting={(selected)=>{setfilter_sorting(selected)}} sorting_option={filter_sorting} onChangeName={(value)=>{setfilter_name(value)}} name_search={filter_name} roles={roles_labels}/>}
                    </div>
                </div>
                <table className={styles.table} style={{marginTop:"1rem"}}>



                    <tbody>
                        <tr className={styles.tableheader_users}>
                            <th>{content_state[ReactSession.get("language")] ? (content_state[ReactSession.get("language")].UserManagement && content_state[ReactSession.get("language")].UserManagement.overview_th_email && content_state[ReactSession.get("language")].UserManagement.overview_th_email) : "E-mail address"}</th>
                            <th>{content_state[ReactSession.get("language")] ? (content_state[ReactSession.get("language")].UserManagement && content_state[ReactSession.get("language")].UserManagement.overview_th_role && content_state[ReactSession.get("language")].UserManagement.overview_th_role) : "Role"}</th>
                            <th>{content_state[ReactSession.get("language")] ? (content_state[ReactSession.get("language")].UserManagement && content_state[ReactSession.get("language")].UserManagement.overview_th_firstname && content_state[ReactSession.get("language")].UserManagement.overview_th_firstname) : "First name"}</th>
                            <th>{content_state[ReactSession.get("language")] ? (content_state[ReactSession.get("language")].UserManagement && content_state[ReactSession.get("language")].UserManagement.overview_th_lastname && content_state[ReactSession.get("language")].UserManagement.overview_th_lastname) : "Last name"}</th>
                            <th>{content_state[ReactSession.get("language")] ? (content_state[ReactSession.get("language")].UserManagement && content_state[ReactSession.get("language")].UserManagement.overview_th_language && content_state[ReactSession.get("language")].UserManagement.overview_th_language) : "Language"}</th>
                            <th>Groep</th>
                            <th style={{width:"6rem"}}></th>
                        </tr>
 

                        {Array.isArray(onFilter(users)) && onFilter(users).length > 0 && onFilter(users).map((v, i)=>{
                            return (
                                <tr key={i} >
                                    <td>{v.username}</td>
                                    <td>{getFullRole(v.role)}</td>
                                    <td>{v.firstname}</td>
                                    <td>{v.lastname}</td>
                                    <td>{(v.relnr.toString().length > 1 && v.relnr !== "0000000000") && v.relnr}</td>
                                    <td>{parseFloat(v.group) > 0 && handleGroupidToGroupname(v.group.toString())}</td>
                                    <td className={style.icons_container}>
                                        <TooltipProvider>
                                            <Tooltip delayDuration={0}>
                                                <TooltipTrigger asChild>
                                                    <button id={v.apiuserid} name={v.username} onClick={(e)=>{handleClickDeleteUser(e)}} className="flex items-center justify-center w-7 h-7 min-w-7 text-neutral-400 hover:text-neutral-600"><TrashIcon className="w-4 h-4"/></button>
                                                </TooltipTrigger>
                                                <TooltipContent>
                                                    <p>Gebruiker verwijderen</p>
                                                </TooltipContent>
                                            </Tooltip>

                                            <Tooltip delayDuration={0}>
                                                <TooltipTrigger asChild>
                                                    <button id={v.apiuserid} name={v.username} onClick={(e)=>{setselectedSubpage("Detail"); handleClickEdit(e)}} className="flex items-center justify-center w-7 h-7 min-w-7 text-neutral-400 hover:text-neutral-600"><Edit2Icon className="w-4 h-4"/></button>
                                                </TooltipTrigger>
                                                <TooltipContent>
                                                    <p>Gebruiker wijzigen</p>
                                                </TooltipContent>
                                            </Tooltip>

                                            {!v.verified && 
                                            <Tooltip delayDuration={0}>
                                                <TooltipTrigger asChild>
                                                    <button id={v.apiuserid} name={v.username} onClick={(e)=>{handleClickSendMail(e)}} className="flex items-center justify-center w-7 h-7 min-w-7 text-neutral-400 hover:text-neutral-600"><MailIcon className="w-4 h-4"/></button>
                                                </TooltipTrigger>
                                                <TooltipContent>
                                                    <p>Registratie mail opnieuw sturen</p>
                                                </TooltipContent>
                                            </Tooltip>}
                                        </TooltipProvider>
                                    </td>
                                </tr>
                            )
                        })}  


                                   
                    </tbody>
                    
                </table>
            </div>
            : 
            selectedSubpage === "Toevoegen" ?
            <>
            <AddUser />
            </>
            :
            selectedSubpage === "Detail" ?
            <>
            <EditUser user={edituser}/>
            </>         
            : 
            selectedSubpage === "Rechten" ?
            <div className={style.sub_content}>
                <p className={`${style.sub_content_title} mb-2`}>{content_state[ReactSession.get("language")] ? (content_state[ReactSession.get("language")].UserManagement && content_state[ReactSession.get("language")].UserManagement.rights_button && content_state[ReactSession.get("language")].UserManagement.rights_button) : "Rights"}</p>
                
                {rights_subpage === '1' ? 
                <>
                    <div className={style.role_top}>
                        <Tablist value={rights_subpage} onValueChange={(value)=>{ setrights_subpage(value) }} items={[{label:'Rollen', value:'1'}, {label:'Gebruikers', value:'2'}]} />
                        <div className={style.header_buttons_row}>
                        <button className={style.reloadsettings_button} onClick={()=>{reloadDossierSettings()}}><p>Volledigheid dossiers checken</p><img src={refresh_icon_white} alt="settings icon"/></button>
                        <button className={style.rightssettings_button} onClick={()=>{setselectedSubpage("Rechten_Instellingen")}}><p>{content_state[ReactSession.get("language")] ? (content_state[ReactSession.get("language")].UserManagement && content_state[ReactSession.get("language")].UserManagement.rights_doctype_settings && content_state[ReactSession.get("language")].UserManagement.rights_doctype_settings) : "Documenttype settings"}</p><img src={settings_icon_white} alt="settings icon"/></button>
                        <button className={style.reset_button} onClick={()=>{handleClickResetRights()}}><p>{content_state[ReactSession.get("language")] ? (content_state[ReactSession.get("language")].UserManagement && content_state[ReactSession.get("language")].UserManagement.rights_resetrights && content_state[ReactSession.get("language")].UserManagement.rights_resetrights) : "Reset all permissions"}</p><img src={warning_icon_white} alt="delete icon"/></button></div></div>   
                    <div className={style.roles_legend}>
                        <div style={{backgroundColor:"#0F9B57"}} className={style.roles_legend_item}>{content_state[ReactSession.get("language")] ? (content_state[ReactSession.get("language")].General && content_state[ReactSession.get("language")].General.roles_provider && content_state[ReactSession.get("language")].General.roles_provider) : "Provider"}</div>
                        <div style={{backgroundColor:"#D34E4E"}} className={style.roles_legend_item}>{content_state[ReactSession.get("language")] ? (content_state[ReactSession.get("language")].General && content_state[ReactSession.get("language")].General.roles_customer && content_state[ReactSession.get("language")].General.roles_customer) : "Customer"}</div>
                        <div style={{backgroundColor:"#4168D3"}} className={style.roles_legend_item}>{content_state[ReactSession.get("language")] ? (content_state[ReactSession.get("language")].General && content_state[ReactSession.get("language")].General.roles_recognized_fertilizer && content_state[ReactSession.get("language")].General.roles_recognized_fertilizer) : "Recognized Fertilizer (RF)"}</div>
                    </div>  
                    <div className={style.rights_container}> 
                    { 
                    (dosrights && dostypes) && 
                    dosrights.length > 0 &&                          
                        <table className={styles.table} style={{tableLayout:"fixed", width:"unset", minWidth:"-webkit-fill-available"}}>
                            <tbody>
                                <tr>
                                    <th></th>
                                    {tableitems.length > 0 && 
                                        tableitems.map((v, i)=>{
                                        return (

                                            <th key={i} style={{minWidth:"6rem", textAlign:"center"}}>{doctypesTranslations[v][ReactSession.get("language")]}</th>
                                        )
                                    })}
                                </tr>
                                {dostypes.length > 0 && 
                                dostypes.map((val, i)=>{
                                    return (
                                        <tr key={i}>
                                            <td style={{position:"sticky", left:"0", zIndex:"1", backgroundColor:"rgba(255,255,255,0.8)", backdropFilter:"blur(8px)"}}><div style={{fontWeight:"600"}}>{filetypesTranslations[val.name] ? filetypesTranslations[val.name][ReactSession.get("language")] : val.name}</div></td>
                                            {dosrights.map((value, index)=>{
                                                return (
                                                    <React.Fragment key={index}>
                                                        {(val.dossiertypeid === value.filetype && value.doctypes) &&
                                                        value.doctypes.map((va, ind)=>{
                                                            
                                                            return (
                                                                <td key={ind}>
                                                                    <div className={style.checkbox_content}>
                                                                        
                                                                        {roles && roles.map((val_roles, ind_roles)=>{
                                                                            if(val_roles.id !== 1){
                                                                                const BLUE = "#4168d3";
                                                                                const GREEN = "#0f9b57";
                                                                                const RED = "#d34e4e";
                                                                                return (
                                                                                    <div id={val_roles.id+"_"+val.dossiertypeid+"_"+va.doctype} key={ind_roles} className={style.checkbox_item}><Checkbox checked={va.users.includes(val_roles.id)} color={val_roles.id === 2 ? BLUE : val_roles.id === 3 ? RED : GREEN} onChange={(e)=>{handleChangeRights(e, val_roles.id.toString())}}/></div>
                                                                                )
                                                                            }                         
                                                                        })}

                                                                    </div>
                                                                </td>
                                                            )

                                                        })
                                                        }
                                                    </React.Fragment>
                                                )
                                            })}
                                        </tr>
                                    )
                                })
                                }                 
                            </tbody>
                        </table>
                    }
                    </div>  
                </>
                :
                rights_subpage === '2' ?
                    <>
                        <Tablist value={rights_subpage} onValueChange={(value)=>{ setrights_subpage(value) }} items={[{label:'Rollen', value:'1'}, {label:'Gebruikers', value:'2'}]} />
                        <UserRights users={users} onSuccess={()=>{handleGetUsers()}}/>
                    </>
                    :
                    <>Something went wrong</>
                }
            </div>
            :
            selectedSubpage === "Rechten_Instellingen" ?
            <div className={style.sub_content}>
                <div className={style.role_top}><p className={style.sub_content_title}>{content_state[ReactSession.get("language")] ? (content_state[ReactSession.get("language")].UserManagement && content_state[ReactSession.get("language")].UserManagement.doctypesettings_title && content_state[ReactSession.get("language")].UserManagement.doctypesettings_title) : "Document type settings"}</p></div>
                <p className={style.sub_content_description}>{content_state[ReactSession.get("language")] ? (content_state[ReactSession.get("language")].UserManagement && content_state[ReactSession.get("language")].UserManagement.doctypesettings_description && content_state[ReactSession.get("language")].UserManagement.doctypesettings_description) : "Add document types where permissions apply"}</p>
                <div className={style.settings_container}>
                    <div className={style.settings_filter}>
                        <div className={style.settings_dropdownlist}>
                            {listitems &&
                            <Dropdownlist type="DOCTYPE" data={listitems} enableMultipleItems onChange={(e)=>{console.log(e); setselectedDoctypes(e)}} placeholder={content_state[ReactSession.get("language")] ? (content_state[ReactSession.get("language")].UserManagement && content_state[ReactSession.get("language")].UserManagement.doctypesettings_dropdown_placeholder && content_state[ReactSession.get("language")].UserManagement.doctypesettings_dropdown_placeholder) : "Select document types"} valueForm="all" clear={clearDoctypesDdl ? clearDoctypesDdl : false}/>
                            }
                            
                        </div>
                        <button onClick={()=>{handleClickAddItems()}} className={style.settings_add_button}>{content_state[ReactSession.get("language")] ? (content_state[ReactSession.get("language")].UserManagement && content_state[ReactSession.get("language")].UserManagement.doctypesettings_button_additems && content_state[ReactSession.get("language")].UserManagement.doctypesettings_button_additems) : "Add items"}</button>
                    </div>
                    <div className={style.settings_overview}>
                        <p style={{fontWeight:"600"}}>{content_state[ReactSession.get("language")] ? (content_state[ReactSession.get("language")].UserManagement && content_state[ReactSession.get("language")].UserManagement.doctypesettings_title_overview && content_state[ReactSession.get("language")].UserManagement.doctypesettings_title_overview) : "Overview"}</p>
                        
                        {(tableitems && tableitems[0] !== null) && tableitems.map((v, i)=>{
                            return (
                                <div className={style.settings_row} key={i}>
                                    <p className={style.setting_row_type}>{doctypesTranslations[v][ReactSession.get("language")]}</p>
                                    <button name={v} onClick={(e)=>{handleClickDeleteDoctype(e)}} className={style.icon_button}><img src={bin_icon_black} alt="delete icon"/><span className={style.tooltiptext} style={{marginLeft:"-50px"}}>Delete documenttype</span></button>
                                </div>
                            )
                        })}
                    </div>
                    
                </div>
            </div> 
            :
            selectedSubpage === "Begeleidend document" ?
            <div className={style.sub_content}>
                <div className={style.fixed_cards}>
                    <div onClick={()=>{setfixedDocPage("BEGELEIDDOC"); setfixedDocPeriod("Standaard")}} className={fixedDocPage === "BEGELEIDDOC" ? style.fixed_doc_card_active : style.fixed_doc_card}>
                        <div className={style.fixed_doc_card_top}>
                            <p>Begeleidend document</p>
                            {fixedDocPage === "BEGELEIDDOC" && <div className={style.fixed_doc_card_check}><img src={check_white} alt="check"/></div>}
                        </div>
                        <p className={style.fixed_doc_card_description}>Stel het begeleidend document in dat wordt meegegeven met de dossiers. </p>
                    </div>

                    <div onClick={()=>{setfixedDocPage("NFU"); setfixedDocPeriod("Standaard")}} className={fixedDocPage === "NFU" ? style.fixed_doc_card_active : style.fixed_doc_card}>
                        <div className={style.fixed_doc_card_top}>
                            <p>NFU document</p>
                            {fixedDocPage === "NFU" && <div className={style.fixed_doc_card_check}><img src={check_white} alt="check"/></div>}
                        </div>
                        <p className={style.fixed_doc_card_description}>Stel het NFU document in dat wordt meegegeven met de dossiers. </p>
                    </div>
                </div>

                <div className={style.devider}></div>
                
                {/* BEGELEIDENDDOC */}
                {fixedDocPage === "BEGELEIDDOC" &&
                <div>
                    <div className={style.fxd_period_header}><h2>Perioden</h2></div>
                    <div className={style.fxd_period_buttons}>
                        {Object.keys(fixedDocSettings.BEGELEIDDOC).map((v, i)=> {
                            return (
                                <button key={i} className={v !== "Standaard" ? (fixedDocPeriod === v ? style.fxd_period_btn_active : style.fxd_period_btn) : (fixedDocPeriod === v ? style.fxd_period_btn_standard_active : style.fxd_period_btn_standard)}>
                                    <p onClick={()=>setfixedDocPeriod(v)}  className={v !== "Standaard" ? style.fxd_period_btn_text : ''}>{v !== "Standaard" ? yyyymmddToLong(v.split("-")[0]) + " - " + yyyymmddToLong(v.split("-")[1]) : v} </p>
                                    {v !== "Standaard" && <span onClick={()=>{deletePeriodFixedDocs("BEGELEIDDOC", v)}}><img src={bin_icon_black} alt="bin"/></span>}
                                </button>
                            )
                        })}
                        
                        {/* <button className={style.fxd_period_btn_active}>13 September 2022 - 23 Oktober 2022 <span><img src={bin_icon_black} alt="bin"/></span></button> */}
                        <DatepickerRange onClear={clearDateRange} icon={calendar_white} label="Nieuwe periode" onPickDate={(dates)=>{handleAddBDOCPeriod(dates)}} type="fixeddoc"/>
                    </div>

                    <div className={style.fxd_document_header}><h2>Documenten</h2></div>
                    <div style={{display:"flex", gap:"1rem", flexWrap:"wrap", flexDirection:"column"}}>

                        {/* {console.log(fixedDocSettings.BEGELEIDDOC[fixedDocPeriod])} */}

                        {bdocItems.map((v, i)=>{
                            return (
                            <div key={i}>
                                <BdocCard onChange={(v)=>handleClickBdocCard(v)} name={v.filename} id={v.docid} checked={fixedDocSettings.BEGELEIDDOC[fixedDocPeriod] && fixedDocSettings.BEGELEIDDOC[fixedDocPeriod].toString() === (v.docid.toString()) ? true : false} viewDocument={()=>{handleShowDocument(v.docid)}}/>
                            </div>
                            )
                        })}

                    </div>
                </div>
                }

                {/* NFU */}
                {fixedDocPage === "NFU" &&
                <div>
                    <div className={style.fxd_period_header}><h2>Perioden</h2></div>
                    <div className={style.fxd_period_buttons}>
                        {Object.keys(fixedDocSettings.NFU).map((v, i)=> {
                            return (
                                <button key={i} className={v !== "Standaard" ? (fixedDocPeriod === v ? style.fxd_period_btn_active : style.fxd_period_btn) : (fixedDocPeriod === v ? style.fxd_period_btn_standard_active : style.fxd_period_btn_standard)}>
                                    <p onClick={()=>setfixedDocPeriod(v)}  className={v !== "Standaard" ? style.fxd_period_btn_text : ''}>{v !== "Standaard" ? yyyymmddToLong(v.split("-")[0]) + " - " + yyyymmddToLong(v.split("-")[1]) : v} </p>
                                    {v !== "Standaard" && <span onClick={()=>{deletePeriodFixedDocs("NFU", v)}}><img src={bin_icon_black} alt="bin"/></span>}
                                </button>
                            )
                        })}
                        
                        {/* <button className={style.fxd_period_btn_active}>13 September 2022 - 23 Oktober 2022 <span><img src={bin_icon_black} alt="bin"/></span></button> */}
                        <DatepickerRange onClear={clearDateRange} icon={calendar_white} label="Nieuwe periode" onPickDate={(dates)=>{handleAddNFUPeriod(dates)}} type="fixeddoc"/>
                    </div>

                    <div className={style.fxd_document_header}><h2>Documenten</h2></div>
                    <div style={{display:"flex", gap:"1rem", flexWrap:"wrap", flexDirection:"column"}}>
                        {nfuDocs && Array.isArray(nfuDocs) && nfuDocs.length > 0 && nfuDocs.map((v, i)=>{
                            return (
                            <div key={i}>
                                <BdocCard onChange={(v)=>handleClickNfuCard(v)} name={v.filename} id={v.docid} checked={fixedDocSettings.NFU[fixedDocPeriod] && fixedDocSettings.NFU[fixedDocPeriod].toString() === (v.docid.toString()) ? true : false} viewDocument={()=>{handleShowDocument(v.docid)}}/>
                            </div>
                            )
                        })}
                    </div>
                </div>
                }

            </div> 
            :
            selectedSubpage === "Usergroups" ?
            <UserGroups />
            // <div className={style.sub_content}>
            //     <div className={style.role_top}><p className={style.sub_content_title}>Gebruikersgroepen</p><button onClick={()=>{setshowGroupSettings({})}} className={style.group_add_button}>Nieuwe groep</button></div>
            //     <div className={style.groups_table}>
            //         <div className={`${style.group_container} ${style.group_container_header}`}>
            //             <p className={style.group_name}>Groepsnaam</p>
            //             <p className={style.group_amount}>Aantal relaties</p>
            //             <div className={style.group_settings_actions} style={{visibility:"hidden"}}>
            //                 <button name="action" className={style.group_settings_button}><img name="action" src={edit_icon_black} alt="settings icon"/></button>
            //                 <button className={style.group_settings_button}><img src={bin_icon_black} alt="delete"/></button>
            //             </div>
            //         </div>
                    

            //         {Array.isArray(allgroups) && allgroups.map((v, i)=>{
            //             return (
            //                 <div className={style.group_container} key={i}>
            //                     <p className={style.group_name}>{v.name}</p>
            //                     <p className={style.group_amount}>{Array.isArray(v.members) && v.members.length} relaties</p>
            //                     <div className={style.group_settings_actions}>
            //                         <Tooltip text="Groep wijzigen"><button className={style.group_settings_button} onClick={()=>{console.log(v); setshowGroupSettings(v)}}><img src={edit_icon_black} alt="settings icon"/></button></Tooltip>
            //                         <Tooltip text="Groep verwijderen"><button className={style.group_settings_button} onClick={()=>{deleteGroup(v)}}><img src={bin_icon_black} alt="delete"/></button></Tooltip>
            //                     </div>
            //                 </div>
            //             )
            //         })}
                    
                    
            //     </div>
            // </div>
            :
            selectedSubpage === "Volledigheid" ?
            <CompleteTable dostypes={dostypes} doctypes={doctypes}/>
            :
            <div>
                <p>Niet gevonden</p>
            </div>
            }
            
        </div>
	    </>  
  	);
}
 